<div class="risk-container">
  <div class="status-container {{ data?.riskOverview?.riskFtcRating == 'Low' ? 'low' : 'critical' }}">
    <div class="title d-flex flex-row">
      <span class="rc-icon">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      </span>
      <div class="d-flex flex-column gap-1">
        <span>FTC Section 5 Violation Risk</span>
        <risk-heat-meter version="v3" [risk]='data?.riskOverview?.riskFtcRating'></risk-heat-meter>
        <p class="desc mt-2">
          Pixalate’s assessment of potential FTC Section 5 (Unfair and Deceptive Acts or Practices) liability based on
          discrepancies between privacy policy and manifest file disclosures and what location data is actually being
          collected by the SDKs.
        </p>
      </div>
    </div>
  </div>

  <div class="status-container {{ data?.riskOverview?.riskAppStoreRating == 'Low' ? 'low' : 'critical' }}">
    <div class="title d-flex flex-row">
      <span class="rc-icon">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      </span>
      <div class="d-flex flex-column gap-1">
        <span>App Store Guideline Violation Risk</span>
        <risk-heat-meter version="v3" [risk]='data?.riskOverview?.riskAppStoreRating'></risk-heat-meter>
        <p class="desc mt-2">
          Pixalate’s assessment of potential Apple App and Google Play Store violations based on discrepancies between
          privacy policy and manifest file disclosures and what location data is actually being collected by the SDKs.
        </p>

      </div>
    </div>

  </div>
</div>